import "dotenv/config";
import express from "express";
import cookieParser from "cookie-parser";
import mongoose from "mongoose";
import { BRAND, fail } from "./shared";
import { requireConfig, gracefulShutdown } from "./shared/service";
import chatRoutes from "./routes/chat.routes";

/**
 * CHAT SERVICE — messages live in our own database, not on the mail server.
 *
 * It never sees a mailbox password. It trusts the end-user token that webmail
 * issues once the mail server has verified someone, and scopes everything to
 * that person's domain.
 */
requireConfig("chat", {
  required: ["MONGO_URI", "END_USER_JWT_SECRET"],
  optional: { INTERNAL_API_KEY: "the people directory cannot be read" },
  show: ["PORT"],
});

const app = express();
app.use(express.json({ limit: "256kb" }));
app.use(cookieParser());

app.get("/health", (_req, res) => res.json({ ok: true, service: "chat", product: BRAND.product }));
app.use("/api/chat", chatRoutes);

app.use("/api/chat", (_req, res) =>
  fail(res, 404, "UNKNOWN", "No such chat endpoint.")
);

app.use((err: any, _req: any, res: any, _next: any) => {
  console.error("[chat] unhandled:", err);
  res.status(500).json({ error: { code: "INTERNAL", message: "Something went wrong on our side. Please try again." } });
});

const port = Number(process.env.PORT ?? 4004);
await mongoose.connect(process.env.MONGO_URI!);
console.log("[chat] connected to MongoDB");

const server = app.listen(port, () => {
  console.log(`[chat] ${BRAND.product} chat service on http://localhost:${port}`);
  if (!process.env.END_USER_JWT_SECRET) {
    console.warn("[chat] WARNING: END_USER_JWT_SECRET is not set — nobody will be able to sign in.");
  }
});

gracefulShutdown("chat", server, async () => { await mongoose.disconnect(); });
